import { UrlMaintenanceScheduleEditParams } from '../../pages/UptimeMonitoring/config';
import { APIS } from '../../utils/apiConfig';
import { HttpService } from '../HttpService/HttpService';

export class UrlMonitoringService {
  constructor(private httpService: HttpService) {}
  async getUrlMonitoring(params: any): Promise<any> {
    try {
      const response = await this.httpService.post(
        APIS.GET_URL_MONITORING(),
        params
      );
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }

  async addUrlMaintenance(params: any): Promise<any> {
    try {
      const response = await this.httpService.post(
        APIS.ADD_URL_MAINTENANCE(),
        params
      );
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }

  async editUrlMaintenance(params: any): Promise<any> {
    try {
      const response = await this.httpService.patch(
        APIS.EDIT_URL_MAINTENANCE(),
        params
      );
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }

  async addUrlMaintenanceSchedule(params: any): Promise<any> {
    try {
      const response = await this.httpService.post(
        APIS.ADD_MAINTENANCE_SCHEDULE(),
        params
      );
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }

  async editUrlMaintenanceSchedule({
    urlId,
    params
  }: UrlMaintenanceScheduleEditParams): Promise<any> {
    try {
      const response = await this.httpService.put(
        `${APIS.GET_MAINTENANCE_SCHEDULE()}/${urlId}`,
        params
      );
      const { data } = response;
      if (data.sc === 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }

  async getUrlMaintenanceSchedule({ urlId }: {urlId: number }): Promise<any> {
    try {
      const response = await this.httpService.get(
        `${APIS.GET_MAINTENANCE_SCHEDULE()}/${urlId}`
      );

      const { data } = response;
      if (data && data.success && Array.isArray(data.data)) {
        return data.data;  
      }

      return null;
    } catch (e) {
      console.error('Error fetching maintenance schedule', e);
      return null;
    }
  }

  async getSSLDays(): Promise<any> {
    try {
      const response = await this.httpService.get(APIS.GET_SSL_DAYS());
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }
  async setSSLDays(params: { RecommendedDays: string }): Promise<any> {
    try {
      const response = await this.httpService.post(APIS.SET_SSL_DAYS(), params);
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }
  async deleteSSLDays(): Promise<any> {
    try {
      const response = await this.httpService.delete(
        APIS.DELETE_SSL_DAYS(),
        {}
      );
      const { data } = response;
      if (data.sc == 1) {
        return data.result;
      }
    } catch (e) {
      throw e;
    }
  }
}
